// src/app/pages/auth/msal.config.ts
import { BrowserCacheLocation, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

const b2cTenant = environment.b2cTenant;
const b2cDomain = environment.b2cDomain;
const clientId = environment.b2cClientId;
const signUpSignInPolicy = environment.b2cSignUpSignInPolicy;

export const authoritySUSI = `https://${b2cDomain}/${b2cTenant}/${signUpSignInPolicy}`;

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId,
    authority: authoritySUSI,
    knownAuthorities: [b2cDomain],
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level >= LogLevel.Warning) console.warn(message);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
});

export async function initMsal(): Promise<void> {
  await msalInstance.initialize();
}

export const apiScopes = [
  'https://ciamtest01.onmicrosoft.com/cardio-api/tasks.read',
  'https://ciamtest01.onmicrosoft.com/cardio-api/tasks.write',
];

export const protectedResourceMap = new Map<string, Array<string>>([
  // ['/api/*', apiScopes],
]);